import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';
import MenuItem from 'material-ui/MenuItem';
import { TextField, SelectField } from 'redux-form-material-ui';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { grey400 } from 'material-ui/styles/colors';
import { connect } from 'react-redux';
import { localize } from 'react-localize-redux';
import { translate } from 'react-i18next';

import { required } from '../utils/form-validators';
import i18n from '../translations/i18n';

let AlertTypeForm = (props) => {
  const styles = {
    toggleDiv: {
      maxWidth: 300,
      marginTop: 40,
      marginBottom: 5,
    },
    toggleLabel: {
      color: grey400,
      fontWeight: 100,
    },
    buttons: {
      marginTop: 30,
      float: 'right',
    },
    saveButton: {
      marginLeft: 5,
    },
  };

  const { handleSubmit, accounts, selectedAccounts, disableSave, alertType } = props;
  const accountItems = accounts.map((account) => {
  const checked = selectedAccounts.indexOf(account.id) > -1;

    return (
      <MenuItem
        checked={checked}
        insetChildren
        key={account.id}
        value={account.id}
        primaryText={account.email}
      />
    );
  });

  return (
    <form onSubmit={handleSubmit}>
      <Field
        component={TextField}
        validate={[required]}
        name="name"
        hintText={props.t('name')}
        floatingLabelText={props.t('name')}
        fullWidth
      />

      <Field
        component={TextField}
        name="min_value"
        hintText={props.t('minimum_value')}
        floatingLabelText={props.t('minimum_value')}
        fullWidth
      />

      {alertType && alertType.type !== 'LORA_UPDATE' 
      ?
        <Field
          component={TextField}
          name="max_value"
          hintText={props.t('maximum_value')}
          floatingLabelText={props.t('maximum_value')}
          fullWidth
        />
      :
        <Field
          component={TextField}
          type="number"
          name="timePeriodHours"
          hintText={props.t('Time period (hours)')}
          floatingLabelText={props.t('Time period (hours)')}
          fullWidth
        />
      }

      <Field
        name="accounts"
        component={SelectField}
        hintText={props.t('accounts')}
        fullWidth
        multiple
        floatingLabelText={props.t('email_recipients_accounts')}
        style={styles.providerSelect}
      >
        {accountItems}
      </Field>

      <Field
        component={TextField}
        name="emails"
        hintText={props.t('email_recipients_other')}
        floatingLabelText={props.t('email_recipients_other')}
        fullWidth
      />

      <div style={styles.buttons}>
        <Link to="/alert-types">
          <RaisedButton label={props.t('back')} />
        </Link>

        <RaisedButton
          label={props.t('save')}
          style={styles.saveButton}
          type="submit"
          disabled={disableSave}
          primary
        />
      </div>
    </form>
  );
};

AlertTypeForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  accounts: PropTypes.any,
  selectedAccounts: PropTypes.any,
  disableSave: PropTypes.any,
  t: PropTypes.func,
};

AlertTypeForm.defaultProps = {
  disableSave: true,
};

AlertTypeForm = reduxForm({ form: 'alertType' })(AlertTypeForm);
const selector = formValueSelector('alertType');

AlertTypeForm = connect((state) => {
  // can select values
  const selectedAccounts = selector(state, 'accounts') || [];

  return {
    selectedAccounts,
  };
})(AlertTypeForm);

const extended = translate(['translations'], { i18n })(AlertTypeForm);
export default localize(extended, 'locale');



// WEBPACK FOOTER //
// ./src/components/AlertTypeForm.js